import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { useLocation, useNavigate } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { countOfRecourd, registerPrintUrl } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const MyParticipatedEvents = () => {
  const eventContext = useContext(EventContext);
  const navigate = useNavigate();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [idCardLoadingId, setIdCardLoadingId] = useState(null);

  useEffect(() => {
    getEvents();
  }, [search]);

  const getEvents = async () => {
    setLoading(true);
    await useApi.get(
      `/user/event/participated${search}`,
      {},
      (res) => {
        eventContext.events = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const viewIdCard = async (eventId) => {
    const natCode = eventContext.authUser?.nat_code;
    if (!natCode) {
      return error('کد ملی در حساب کاربری یافت نشد');
    }
    setIdCardLoadingId(eventId);
    await useApi.get(
      `/id-card/${eventId}/user/${natCode}`,
      {},
      (res) => {
        const data = res.data.data;
        setIdCardLoadingId(null);
        if (data?.success === false) {
          return error(data?.message ?? 'امکان نمایش کارت شناسایی وجود ندارد');
        }
        navigate('/id-card/show', { state: data });
      },
      (err) => {
        setIdCardLoadingId(null);
        error('هنگام دریافت کارت شناسایی خطایی رخ داده است');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-calendar-star f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            رویدادهای من
          </h1>
        </div>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.events?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>شروع</th>
                <th>پایان</th>
                <th>کد پیگیری</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.events?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.events?.meta?.pagination?.per_page,
                      eventContext.events?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>{item.title}</td>
                  <td>
                    {moment(
                      item.start_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td>
                    {moment(
                      item.end_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td dir='ltr' className='text-center'>
                    {item.issue_tracking ?? '-'}
                  </td>
                  <td>
                    {item.accept_info === 1 ? (
                      <span className='badge badge-success'>تایید شده</span>
                    ) : (
                      <span className='badge badge-warning text-dark'>
                        در انتظار تایید
                      </span>
                    )}
                  </td>
                  <td>
                    <div className='d-flex flex-row flex-wrap'>
                      {item.issue_tracking ? (
                        <a
                          href={registerPrintUrl(
                            item.id,
                            item.issue_tracking,
                            item.type === 1 ? 'user' : 'team',
                          )}
                          target='_blank'
                          rel='noreferrer'
                          className='btn btn-outline-info btn-sm mx-1 mb-1'
                        >
                          پرینت ثبت‌نام
                        </a>
                      ) : null}
                      {item.can_view_id_card ? (
                        <button
                          type='button'
                          className='btn btn-info btn-sm mx-1 mb-1'
                          disabled={idCardLoadingId === item.id}
                          onClick={() => viewIdCard(item.id)}
                        >
                          {idCardLoadingId === item.id ? (
                            <span
                              className='spinner-border spinner-border-sm'
                              role='status'
                            />
                          ) : (
                            <>
                              <i className='fas fa-id-card mx-1'></i>
                              کارت شناسایی
                            </>
                          )}
                        </button>
                      ) : item.has_id_card ? (
                        <span className='f-12 text-muted align-self-center'>
                          پس از تایید مدیریت
                        </span>
                      ) : (
                        <span className='f-12 text-muted align-self-center'>
                          بدون کارت
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3'>
            <span className='f-13 font-weight-bold text-secondary'>
              هنوز در رویدادی ثبت‌نام نکرده‌اید
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.events?.meta?.pagination?.total_pages}
          basePath='/panel/user/my-events'
        />
      </div>
    </Master>
  );
};

export default MyParticipatedEvents;
